function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M826.15,174.027c0,3.133-14.376,5.672-32.11,5.672s-32.11-2.539-32.11-5.672,14.376-5.673,32.11-5.673S826.15,170.893,826.15,174.027Z",
  transform: "translate(-570.518 -45.645)",
  fill: "none",
  stroke: "#62b6ff",
  strokeMiterlimit: 10,
  strokeWidth: 1.5
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M826.151,174.027s9.384,33.155,10.288,67.752C839,339.585,832.1,633.114,832.1,633.114s4.333,56.58-54.314,45.352c-20.623-3.948-21.794-45.352-21.794-45.352s-6.9-293.529-4.346-391.335c0.905-34.6,10.29-67.752,10.29-67.752",
  transform: "translate(-570.518 -45.645)",
  fill: "none",
  stroke: "#62b6ff",
  strokeMiterlimit: 10,
  strokeWidth: 1.5
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M622.206,655.454c-12.628,0-24.93-7.795-34.639-21.948-8.266-12.047-13.444-27.429-13.517-40.144-0.028-3.444-2.782-347.021-2.782-463.741,0-41.075,20.544-72.165,47.787-72.319h0.215c10.064,0,24.292,3.935,34.921,22.678,8.75,15.432,13.188,37.793,13.188,66.466l0.326,421.1c0,72.446-24.649,87.789-45.33,87.9Z",
  transform: "translate(-570.518 -45.645)",
  fill: "none",
  stroke: "#62b6ff",
  strokeMiterlimit: 10,
  strokeWidth: 1.5
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M605,650.525c0.154,0.088,25.645,18.268,81.458,2.675,27.29-9.235,46.368-11.1,68.84-50.9",
  transform: "translate(-570.518 -45.645)",
  fill: "none",
  stroke: "#62b6ff",
  strokeMiterlimit: 10,
  strokeWidth: 1.5
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M602.379,61.575s29.894-18.808,79.584-14.554,68.579,25.186,77.6,47.648S770.474,143.8,770.8,170.114",
  transform: "translate(-570.518 -45.645)",
  fill: "none",
  stroke: "#62b6ff",
  strokeMiterlimit: 10,
  strokeWidth: 1.5
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M627.221,643.023c-20.607.115-37.423-37.724-37.552-60.545,0,0-.227-28.478-0.548-71.661-0.013-1.741-3.746-6.7-3.759-8.484-0.02-2.676,3.68-17.807,3.659-20.583-0.786-106.585-2.013-269.068-2.055-347.335C586.945,97.24,603.428,69.5,624.034,69.387s37.534,24.18,37.565,81.527l0.512,411.842C662.142,619.727,647.829,642.908,627.221,643.023Z",
  transform: "translate(-570.518 -45.645)",
  fill: "none",
  stroke: "#62b6ff",
  strokeMiterlimit: 10,
  strokeWidth: 1.5
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M585.361,502.333s34.365,26.972,76.122-29.969",
  transform: "translate(-570.518 -45.645)",
  fill: "none",
  stroke: "#62b6ff",
  strokeMiterlimit: 10,
  strokeWidth: 1.5
});

function SvgIqos3Duo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 267.241,
    height: 635.046,
    viewBox: "0 0 267.241 635.046",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "iqos_3_duo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIqos3Duo);
export default __webpack_public_path__ + "static/media/iqos_3_duo.bbe6d6022959cd4753bedb7b8acc20dc.svg";
export { ForwardRef as ReactComponent };